import ls from 'local-storage'
import { unhideData } from './hideData'

export default () => {
    const code = ls.get('id')

    if(!code) {
        return false
    } else {
        const unhiddenCode = unhideData(code)
        if (unhiddenCode) {
            const { authenticated } = unhiddenCode
            console.log("AUTH: ", authenticated)
            return authenticated
        } else {
            return false
        }   
    }
}